/* global FB, fbq */
import React, { useEffect } from 'react';
import MainLayout from '../components/MainLayout/MainLayout';
import './pages.css';
import ChatWindow from './ChatWindow';
import { BASE_URL } from '../Config';

const UserManagement = () => {
  useEffect(() => {
    window.fbAsyncInit = function () {
      FB.init({
        appId: '890084659831889',
        cookie: true,
        xfbml: true,
        version: 'v21.0',
      });
    };

    // Load the Facebook SDK
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    // Event listener for session info messages
    const sessionInfoListener = (event) => {
      if (!event.origin || !event.origin.endsWith('facebook.com')) {
        return;
      }

      try {
        const data = JSON.parse(event.data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          handleWhatsAppSignupEvent(data);
        }
      } catch (e) {
        console.log('Non-JSON Response:', event.data);
        const params = new URLSearchParams(event.data);
        const code = params.get('code');
        const domain = params.get('domain');
        console.log('Authorization code:', code);
        console.log('Domain:', domain);
      }
    };

    window.addEventListener('message', sessionInfoListener);

    return () => {
      window.removeEventListener('message', sessionInfoListener);
    };
  }, []);

  const handleWhatsAppSignupEvent = async (data) => {
    if (data.event === 'FINISH') {
      const { phone_number_id, waba_id } = data.data;
      console.log('Phone number ID:', phone_number_id);
      console.log('WhatsApp Business Account ID:', waba_id);
      const email = localStorage.getItem('email');
      try {
        const response = await fetch(`${BASE_URL}/auth/facebook/waba`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ phone_number_id, waba_id, email }),
        });

        if (!response.ok) {
          throw new Error('Failed to save WABA data');
        }

        const result = await response.json();
        console.log(result.message);
      } catch (error) {
        console.error(error.message);
      }
    } else if (data.event === 'ERROR') {
      const { error_message } = data.data;
      console.error('Error:', error_message);
    } else if (data.event === 'CANCEL') {
      const { current_step } = data.data;
      console.warn('Signup canceled at step:', current_step);
    }
  };

  const launchWhatsAppSignup = async () => {
    try {
      if (window.fbq) {
        fbq('trackCustom', 'WhatsAppOnboardingStart', {
          appId: '890084659831889',
          feature: 'whatsapp_embedded_signup',
        });
      }

      const response = await new Promise((resolve, reject) => {
        FB.login(
          (response) => {
            if (response.authResponse) {
              resolve(response.authResponse.code);
            } else {
              reject(new Error('User canceled login or did not fully authorize.'));
            }
          },
          {
            config_id: '1869978156869545',
            response_type: 'code',
            override_default_response_type: true,
            scope: 'business_management, whatsapp_business_management, whatsapp_business_messaging',
            extras: {
              setup: {
                solutionID: '564403362648428',
              },
              featureType: '',
              sessionInfoVersion: 1,
            },
          }
        );
      });

      const userProfileResponse = await fetch(`${BASE_URL}/auth/facebook`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code: response }),
      });

      if (!userProfileResponse.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await userProfileResponse.json();
      console.log('User Profile:', data.userProfile);
    } catch (error) {
      console.error('Error getting user profile:', error);
    }
  };

  const handleLoginClick = () => {
    launchWhatsAppSignup();
  };

  return (
    <MainLayout>
      <div className="user-management">
        <h1>Whatsapp API Management</h1>
        <p>Welcome to the Whatsapp API Management!</p>
        <button
          onClick={handleLoginClick}
          style={{
            backgroundColor: '#1877f2',
            border: 0,
            borderRadius: '4px',
            color: '#fff',
            cursor: 'pointer',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontSize: '16px',
            fontWeight: 'bold',
            height: '40px',
            padding: '0 24px',
          }}
        >
          Login with Facebook
        </button>
      </div>
      <ChatWindow />
    </MainLayout>
  );
};

export default UserManagement;
